import { Box, Link, Typography } from '@mui/material';

import { RouterLink } from 'src/routes/components';

export const CustomLabelWithLink = ({
  label,
  value,
  link,
}: {
  label: string;
  value: string;
  link?: string;
}) => (
  <Box display="flex" flexDirection="column" gap={1} borderRadius={1} bgcolor="background.neutral">
    <Typography fontWeight={600} fontSize={12}>
      {label}
    </Typography>
    <Typography fontSize={12}>
      {link ? (
        <Link
          color="grey.600"
          component={RouterLink}
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          {value}
        </Link>
      ) : (
        value
      )}
    </Typography>
  </Box>
);
